/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authApiKeysExchangeToken } from "../../funcs/authApiKeysExchangeToken.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ExchangeApiKeyTokenRequest$inboundSchema,
};

export const tool$authApiKeysExchangeToken: ToolDefinition<typeof args> = {
  name: "auth-api-keys-exchange-token",
  description: `Exchange API key for a JWT token

Exchange an API key for a short-lived JWT token.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authApiKeysExchangeToken(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
